import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import * as locationsActions from '../locations/actions'
import axios from 'axios'
import { SYSTEM_COMPONENTS_IDS } from '../root/constants'
import { enqueueSnackbar, startLoading, stopLoading } from '../root/actions'
import { getSagasMsgs } from '../root/selectors'

export const watchSharingSaga = [
    takeLatest(actions.REVOKE_SHARING_REQUEST, revokeSharing),
    takeLatest(actions.SHARING_ENTITIES_REQUEST, getSharingEntities),
    takeLatest(actions.SHARE_REQUEST, share)
]

function* revokeSharing(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield call(revokeSharingRequest, action.body)
        yield put(actions.revokeSharingSuccess())
        yield put(enqueueSnackbar({
            message: sagasMsgs.revokeSharingRes,
            options: {
                variant: 'success'
            }
        }))
        if (action.body && action.body.length > 0) {
            if (action.body[0].component_name === SYSTEM_COMPONENTS_IDS.locations) {
                yield put(locationsActions.locationsRequest())
                yield put(locationsActions.locationAssignedUsersRequest(action.body[0].entity_id))
            }
        }
    } catch (ex) {
        yield put(actions.revokeSharingError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.revokeSharingEx,
            options: {
                variant: 'error'
            }
        }))
    }
}

async function revokeSharingRequest(body) {
    await axios.delete(`${process.env.API_URL}/sharing/revoke`, {
        data: body
    })
}

function* getSharingEntities(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const {
            isLocationsGranted,
            isDevicesGranted,
            isReportsGranted
        } = action.isGrantedData
        const sharedUsers = yield call(requestSharedUsers)
        yield put(actions.sharedUsersSuccess(sharedUsers))
        if (isLocationsGranted) {
            const locations = yield call(requestLocations)
            yield put(actions.locationsRequestSuccess(locations))
        }
        if (isDevicesGranted) {
            const devices = yield call(requestDevices)
            yield put(actions.devicesRequestSuccess(devices))
        }
        if (isReportsGranted) {
            const reports = yield call(requestReports)
            yield put(actions.reportsRequestSuccess(reports))
        }
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.sharingEntitiesError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.getSharingDataEx,
            options: {
                variant: 'error'
            }
        }))
        yield put(stopLoading())
    }
}

async function requestSharedUsers() {
    const response = await axios.get(`${process.env.API_URL}/users/shared`)
    return response.data
}

async function requestLocations() {
    const response = await axios.get(`${process.env.API_URL}/locations`, {
        params: {
            is_original: true
        }
    })
    return response.data
}

async function requestDevices() {
    const response = await axios.get(`${process.env.API_URL}/devices`, {
        params: {
            is_original: true
        }
    })
    return response.data
}

async function requestReports() {
    // const response = await axios.get(`${process.env.API_URL}/locations`)
    return []
}

function* share(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const {
            selectedLocations,
            selectedDevices,
            selectedReports
        } = action
        const sharedEntities = yield call(shareRequest, selectedLocations, selectedDevices, selectedReports)
        yield put(actions.shareSuccess())
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.shareError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.shareEx,
            options: {
                variant: 'error'
            }
        }))
        yield put(stopLoading())
    }
}

async function shareRequest(selectedLocations, selectedDevices, selectedReports) {
    let response = []
    if (selectedLocations.length > 0) {
        const sharedLocations = await axios.post(`${process.env.API_URL}/sharing/grant`, selectedLocations)
        response = [...response, ...sharedLocations.data]
    }
    if (selectedDevices.length > 0) {
        const sharedDevices = await axios.post(`${process.env.API_URL}/sharing/grant`, selectedDevices)
        response = [...response, ...sharedDevices.data]
    }
    if (selectedReports.length > 0) {
        const sharedReports = await axios.post(`${process.env.API_URL}/sharing/grant`, selectedReports)
        response = [...response, ...sharedReports.data]
    }
    return response
}
